import {Component} from "react"
import {connect} from "react-redux"
import {initialize} from 'redux-form'
import {toastr} from 'react-redux-toastr'
import Tooltip from "rc-tooltip"
import Aperture from 'react-feather/dist/icons/aperture.js'
import ActivitiesForm, {name as formName} from "../../../../components/Forms/ActivitiesForm/ActivitiesForm.jsx"
import api from '../../../../../api.js'
import {setCurrentFreelance, setCurrentUser} from '../../../../components/CurrentUserLoader/actions.js'

import './Activities.scss'
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx"

class Activities extends Component {
  state = {enrichingSecteurs: false, freshFreelance: null}

  expandSecteurs = (freelance) => {
    const selectedSecteursIds = freelance.secteurs.map(secteur => secteur.id)
    return this.props.secteurs.map(secteur => ({
      ...secteur,
      checked: selectedSecteursIds.includes(secteur.id),
    }))
  }

  submit = (values) => {
    const {freelance} = this.props
    const selectedSecteurs = this.prepareFreelance(values.freelance).secteurs

    if (!selectedSecteurs.length) {
      toastr.error("Veuillez renseigner minimum un secteur pour valider le formulaire.")
      const currentFreelance = this.state.freshFreelance || freelance
      this.props.initializeForm({
        freelance: {...currentFreelance, secteurs: this.expandSecteurs(currentFreelance)}
      })
      return
    }

    return this.props.submit({
      freelance: this.prepareFreelance(values.freelance)
    })
  }

  enrichSecteurs = async () => {
    const {freelance} = this.props
    this.setState({enrichingSecteurs: true})
    try {
      const response = await api.freelances.aiSectors({freelance: freelance.id})
      if (response.data.success) {
        const [freshFreelance, freshUser] = await Promise.all([
          api.freelances.getOne({freelance: freelance.id}),
          api.users.getMe(),
        ])
        this.props.setCurrentFreelance(freshFreelance.data)
        this.props.setCurrentUser(freshUser.data)
        this.setState({freshFreelance: freshFreelance.data})
        toastr.success('Secteurs enrichis avec succès.')
      } else {
        toastr.error(response.data.error)
      }
    } catch (e) {
      toastr.error("Une erreur est survenue lors de l'enrichissement des secteurs.")
    } finally {
      this.setState({enrichingSecteurs: false})
    }
  }

  prepareFreelance = (freelance) => {
    return {
      ...freelance,
      secteurs: freelance.secteurs.reduce((acc, secteur) => {
        if (secteur.checked === true) {
          acc.push(secteur)
        }
        return acc
      }, [])
    }
  }

  render() {
    const {freelance} = this.props
    const {enrichingSecteurs, freshFreelance} = this.state
    const currentFreelance = freshFreelance || freelance

    const enrichButton = (
      <button
        type="button"
        className={`btn btn-secondary btn-sm ${enrichingSecteurs ? 'btn-loading' : ''}`}
        style={enrichingSecteurs ? {opacity: 0.7} : undefined}
        disabled={freelance.experiences.length < 2 || enrichingSecteurs}
        onClick={this.enrichSecteurs}
      >
        {enrichingSecteurs
          ? <svg style={{width: 14, height: 14, animation: 'loader-rotate 1s linear infinite', marginRight: 6, marginBottom: 3, verticalAlign: 'middle', flexShrink: 0}} viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeDasharray="50 150" /></svg>
          : <Aperture size={14} style={{marginRight: 6}} />
        }
        Enrichir les secteurs
      </button>
    )

    return (
      <div>
        <FreelancePage className="p-5">
          <div className="d-flex align-items-center justify-content-center mb-3">
            <h2 className="mb-0">Secteurs</h2>
          </div>

          <div className="text-center mb-3">Merci d'indiquer les secteurs dans lesquels vous avez travaillé pendant au moins 1 an (et non ceux dans lesquels vous souhaitez travailler).</div>

          <div className="text-center mb-5 pb-3">
            {freelance.experiences.length < 2
              ? <Tooltip placement="bottom" overlay="Renseignez minimum 2 missions pour pouvoir enrichir automatiquement les secteurs.">{enrichButton}</Tooltip>
              : enrichButton
            }
          </div>

          <ActivitiesForm
            enableReinitialize={true}
            onSubmit={this.submit}
            onSubmitSuccess={this.props.onFormSuccess}
            disabled={enrichingSecteurs}
            initialValues={{
              freelance: {...currentFreelance, secteurs: this.expandSecteurs(currentFreelance)}
            }}/>
        </FreelancePage>
      </div>
    )
  }
}

export default connect(
  state => ({
    secteurs: state.secteurs.secteurs
  }),
  dispatch => ({
    setCurrentFreelance: (freelance) => dispatch(setCurrentFreelance(freelance)),
    setCurrentUser: (user) => dispatch(setCurrentUser(user)),
    initializeForm: (values) => dispatch(initialize(formName, values)),
  })
)(Activities)
